import AvatarI from "../../img/avatar.png";
import LogoI from "../../img/logo.png";
import BikeDeliveryI from "../../img/delivery.png";
import HeroBgI from "../../img/aaa.png";
import EmptyCartI from "../../img/emptyCart.svg";
import NotFoundI from "../../img/NotFound.svg";
import Visa from "../../img/visa.png";
import Momo from "../../img/momo.png";

// Showcase Banner Static Assets
import FishI from "../../img/fi3.png";
import BaklavaI from "../../img/Baklava1.png";
import KebabI from "../../img/Kebab1.png";
import SpaghettiI from "../../img/Spaghetti.png";
import CevicheI from "../../img/Ceviche.png";
import GyrosI from "../../img/Gyros1.jpg"
import LasagnaI from "../../img/Lasagna.png"
import OctopusI from "../../img/Octopus.png"
import KofteI from "../../img/Kofte.png"
import ParmegianaI from "../../img/Parmegiana1.png"
import PideI from "../../img/Pide.png"
import PizzaI from "../../img/Pizza.jpg"
import SouvlakiI from "../../img/Souvlaki.png"
import MoussakaI from "../../img/Moussaka.png"
import TiramisuI from "../../img/Tiramisu.png"
import TzatzikiI from "../../img/Tzatziki.jpg"
import IcecreamII from "../../img/i2.png"
import GalaktobourekoI from "../../img/Galaktoboureko.png"


// Exports
export const Logo = LogoI
export const Avatar = AvatarI
export const BikeDelivery = BikeDeliveryI
export const HeroBg = HeroBgI
export const Fish = FishI
export const EmptyCartImg = EmptyCartI
export const NotFoundImg = NotFoundI
export const CreditCard = Visa
export const MOMO = Momo
export const Baklava = BaklavaI
export const Kebab = KebabI
export const Spaghetti = SpaghettiI
export const Ceviche = CevicheI
export const Lasagna = LasagnaI
export const Gyros = GyrosI
export const Kofte = KofteI
export const Octopus = OctopusI
export const Parmegiana = ParmegianaI
export const Pide = PideI
export const Pizza = PizzaI
export const Souvlaki = SouvlakiI
export const Moussaka = MoussakaI
export const Tiramisu = TiramisuI
export const Tzatziki = TzatzikiI
export const Icecream = IcecreamII
export const Galaktoboureko = GalaktobourekoI